import { UserId } from '@cibo/core'
import { AutocompleteField, AutocompleteFieldProps } from '@cibo/ui'
import { useField } from 'formik'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { usePaginatedFarms } from '../../../../../queries'

const optionTest = (option: { id: string }, value: { id: string }) => {
  return value?.id === option?.id
}

type AssignFarmFieldProps = Omit<AutocompleteFieldProps, 'name'> & {
  name: string
  farmerId?: UserId
}

export const AssignFarmField = ({
  name = 'farm',
  farmerId,
  ...autocompleteProps
}: AssignFarmFieldProps) => {
  const { t } = useTranslation('@cibo/landmanager/AssignFarmDialog')
  const [fullText, setFullText] = useState('')

  const paginatedFarms = usePaginatedFarms({
    fullText,
    owner: farmerId,
  })

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, __, { setValue }] = useField(name)

  const noneOption = { id: 'none', name: t('noFarm') }

  return (
    <AutocompleteField
      sx={{ minWidth: 350, ...autocompleteProps.sx }}
      name={name}
      loading={paginatedFarms.isLoading}
      options={[noneOption, ...(paginatedFarms.data?.items || [])]}
      getOptionLabel={option => option?.name}
      selectOnFocus
      isOptionEqualToValue={optionTest}
      filterOptions={x => x}
      onInputChange={(_, value) => setFullText(value)}
      onChange={(event, value: { id: string; name: string; owner: string }) => {
        if (!value && event.type === 'click') {
          setValue(noneOption)
        } else {
          setValue(value)
        }
      }}
      {...autocompleteProps}
    />
  )
}
